import { ParsedPackage } from "./types";
import { buildParsedPackage } from "./presets";

export function parseCpList(value: string) {
  return value
    .split(/\n|,|;/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function parsePackages(value: string): ParsedPackage[] {
  return value
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [weight, height, width, length] = line
        .split(",")
        .map((item) => Number(item.trim()));

      if (!weight || !height || !width || !length) {
        throw new Error(
          `Formato inválido en paquete: "${line}". Usar peso,alto,ancho,largo`
        );
      }

      return buildParsedPackage({
        weight,
        height,
        width,
        length,
      });
    });
}